/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingScores } from './gradingScores';
import type { GradingComment } from './gradingComment';
import type { GradingGrade } from './gradingGrade';
import type { GradingGradedAt } from './gradingGradedAt';
import type { GradingAdminOverride } from './gradingAdminOverride';

/**
 * Represents grading of a full module
 */
export interface Grading {
  scores?: GradingScores;
  comment?: GradingComment;
  grade?: GradingGrade;
  gradedAt?: GradingGradedAt;
  adminOverride?: GradingAdminOverride;
}
